export const wait = (timeout: number) =>
  new Promise((res) => setTimeout(res, timeout));
